import {
  SERVICES_ADMIN_ADD_FAVOURITE,
  SERVICES_ADMIN_FETCH_ALL_CONTACT,
  SERVICES_ADMIN_FETCH_ALL_CONTACT_SUCCESS,
  SERVICES_ADMIN_FILTER_CONTACT,
  SERVICES_ADMIN_GET_ALL_CONTACT,
  SERVICES_ADMIN_GET_UNSELECTED_ALL_CONTACT,
  SERVICES_ADMIN_HANDLE_REQUEST_CLOSE,
  SERVICES_ADMIN_HIDE_CONTACT_LOADER,
  SERVICES_ADMIN_ON_ADD_CONTACT,
  SERVICES_ADMIN_ON_ALL_CONTACT_SELECT,
  SERVICES_ADMIN_ON_CONTACT_CLOSE,
  SERVICES_ADMIN_ON_CONTACT_SELECT,
  SERVICES_ADMIN_ON_DELETE_CONTACT,
  SERVICES_ADMIN_ON_DELETE_SELECTED_CONTACT,
  SERVICES_ADMIN_ON_FILTER_OPTION_SELECT,
  SERVICES_ADMIN_ON_SAVE_CONTACT,
  SERVICES_ADMIN_ON_TOGGLE_DRAWER,
  SERVICES_ADMIN_SHOW_MESSAGE,
  SERVICES_ADMIN_UPDATE_SEARCH_USER,
  CHANGE_SERVICES_ADMIN_DISPLAY,
  SUBMIT_NEW_SERVICES_ADMIN,
  SUBMIT_NEW_SERVICES_ADMIN_RESPONSE,
  FILL_ADMIN_SERVICES_SELECTED_DETAILS,
  CHANGE_ADD_SERVICES_STATE,
  CHANGE_EDIT_SERVICES_STATE,
  SUBMIT_EDIT_SERVICES_DETAILS,
  SUBMIT_EDIT_SERVICES_DETAILS_RESPONSE,
  SERVICES_CLEAR_FORM_DATA,
  SELECTED_SERVICES_DELETE,
  SELECTED_SERVICES_DELETE_RESPONSE,
  GET_SERVICES_CATEGORY,
  SET_SERVICES_CATEGORY,
  SET_SERVICES_BUSINESS_CATEGORY,
  SELECT_CATEGORY_ID,
  SELECT_SERVICES_ID,
  EDIT_SERVICE,
  DELETE_SERVICE,
  EDIT_SERVICE_REPONSE,
  DELETED_SERVICE_RESPONSE,
  SERVICES_FAIL_RESPONSE,
  SERVICES_ON_HIDE_LOADER2,
  SERVICES_ON_SHOW_LOADER,
  SERVICES_DELETE_MODAL_TOGGLE,
  HAVE_APPOINTMENT_DELETE_SERVICES,
  APPOINTMENT_DELETE_SERVICES_FORCEFULLY,
  APPOINTMENT_DELETE_SERVICES_FORCEFULLY_RESPONSE,
  GET_SERVICES_CATEGORY_SUPER_ADMIN,
  SUBMIT_NEW_SERVICES_SUPER_ADMIN,
  DELETE_SERVICE_SUPER_ADMIN,
  APPOINTMENT_DELETE_SERVICES_FORCEFULLY_SUPER_ADMIN,
  SERVICES_CATEGORY_ADMIN_UPDATE_SEARCH_USER,
  ADD_SERVICES_BUSINESS_CATEGORY,
} from "constants/ActionTypes";

export const servicesAdminFetchContacts = () => ({
  type: SERVICES_ADMIN_FETCH_ALL_CONTACT,
});

export const servicesAdminFetchContactsSuccess = contact => ({
  type: SERVICES_ADMIN_FETCH_ALL_CONTACT_SUCCESS,
  payload: contact,
});
export const servicesAdminShowContactMessage = message => ({
  type: SERVICES_ADMIN_SHOW_MESSAGE,
  payload: message,
});
export const servicesAdminAddFavourite = data => ({
  type: SERVICES_ADMIN_ADD_FAVOURITE,
  payload: data,
});
export const servicesAdminOnContactSelect = data => ({
  type: SERVICES_ADMIN_ON_CONTACT_SELECT,
  payload: data,
});

export const servicesAdminOnAddContact = () => ({
  type: SERVICES_ADMIN_ON_ADD_CONTACT,
  payload: "",
});
export const servicesAdminOnContactClose = () => ({
  type: SERVICES_ADMIN_ON_CONTACT_CLOSE,
  payload: "",
});
export const servicesAdminOnFilterOptionSelect = option => ({
  type: SERVICES_ADMIN_ON_FILTER_OPTION_SELECT,
  payload: option,
});
export const servicesAdminOnSaveContact = data => ({
  type: SERVICES_ADMIN_ON_SAVE_CONTACT,
  payload: data,
});
export const servicesAdminOnDeleteContact = data => ({
  type: SERVICES_ADMIN_ON_DELETE_CONTACT,
  payload: data,
});
export const servicesAdminOnDeleteSelectedContact = () => ({
  type: SERVICES_ADMIN_ON_DELETE_SELECTED_CONTACT,
  payload: "",
});
export const servicesAdminFilterContact = userName => ({
  type: SERVICES_ADMIN_FILTER_CONTACT,
  payload: userName,
});
export const servicesAdminGetAllContact = () => ({
  type: SERVICES_ADMIN_GET_ALL_CONTACT,
  payload: "",
});
export const servicesAdminGetUnselectedAllContact = () => ({
  type: SERVICES_ADMIN_GET_UNSELECTED_ALL_CONTACT,
  payload: "",
});
export const servicesAdminOnAllContactSelect = () => ({
  type: SERVICES_ADMIN_ON_ALL_CONTACT_SELECT,
  payload: "",
});
export const servicesAdminUpdateContactUser = userName => ({
  type: SERVICES_ADMIN_UPDATE_SEARCH_USER,
  payload: userName,
});
export const servicesCategoryAdminUpdateContactUser = userName => ({
  type: SERVICES_CATEGORY_ADMIN_UPDATE_SEARCH_USER,
  payload: userName,
});
export const servicesAdminOnToggleDrawer = () => ({
  type: SERVICES_ADMIN_ON_TOGGLE_DRAWER,
});
export const servicesAdminHandleRequestClose = () => ({
  type: SERVICES_ADMIN_HANDLE_REQUEST_CLOSE,
});
export const servicesAdminHideContactLoader = () => ({
  type: SERVICES_ADMIN_HIDE_CONTACT_LOADER,
});

export const changeServicesAdminDisplay = payload => ({
  type: CHANGE_SERVICES_ADMIN_DISPLAY,
  payload,
});

export const submitNewServicesAdmin = payload => ({
  type: SUBMIT_NEW_SERVICES_ADMIN,
  payload,
});

export const submitNewServicesSuperAdmin = payload => ({
  type: SUBMIT_NEW_SERVICES_SUPER_ADMIN,
  payload,
});

export const submitNewServicesAdminResponse = payload => ({
  type: SUBMIT_NEW_SERVICES_ADMIN_RESPONSE,
  payload,
});

export const fillAdminServicesSelectedDetails = payload => ({
  type: FILL_ADMIN_SERVICES_SELECTED_DETAILS,
  payload,
});

export const changeAddServicesState = payload => ({
  type: CHANGE_ADD_SERVICES_STATE,
  payload,
});

export const changeEditServicesState = payload => ({
  type: CHANGE_EDIT_SERVICES_STATE,
  payload,
});

export const submitEditServicesDetails = payload => ({
  type: SUBMIT_EDIT_SERVICES_DETAILS,
  payload,
});

export const submitEditServicesDetailsResponse = payload => ({
  type: SUBMIT_EDIT_SERVICES_DETAILS_RESPONSE,
  payload,
});

export const servicesClearFormData = payload => ({
  type: SERVICES_CLEAR_FORM_DATA,
  payload,
});

export const selectedServicesDelete = payload => ({
  type: SELECTED_SERVICES_DELETE,
  payload,
});
export const selectedServicesDeleteResposne = payload => ({
  type: SELECTED_SERVICES_DELETE_RESPONSE,
  payload,
});

export const getServicesCategory = () => ({
  type: GET_SERVICES_CATEGORY,
});

export const getServicesSuperAdminCategory = () => ({
  type: GET_SERVICES_CATEGORY_SUPER_ADMIN,
});

export const setServicesCategory = payload => ({
  type: SET_SERVICES_CATEGORY,
  payload,
});

export const setServicesBusinessCategory = payload => ({
  type: SET_SERVICES_BUSINESS_CATEGORY,
  payload,
});

export const selectCategoryId = payload => ({
  type: SELECT_CATEGORY_ID,
  payload,
});

export const selectServicesId = payload => ({
  type: SELECT_SERVICES_ID,
  payload,
});

export const editService = payload => ({
  type: EDIT_SERVICE,
  payload,
});

export const editServiceResponse = payload => ({
  type: EDIT_SERVICE_REPONSE,
  payload,
});

export const deleteService = payload => ({
  type: DELETE_SERVICE,
  payload,
});

export const deleteServiceSuperAdmin = payload => ({
  type: DELETE_SERVICE_SUPER_ADMIN,
  payload,
});

export const deleteServiceResponse = payload => ({
  type: DELETED_SERVICE_RESPONSE,
  payload,
});

export const servicesFailResponse = payload => ({
  type: SERVICES_FAIL_RESPONSE,
  payload,
});

export const servicesOnHideLoader = payload => ({
  type: SERVICES_ON_HIDE_LOADER2,
  payload,
});

export const servicesOnShowLoader = payload => ({
  type: SERVICES_ON_SHOW_LOADER,
  payload,
});

export const servicesDeleteModalToggle = payload => ({
  type: SERVICES_DELETE_MODAL_TOGGLE,
  payload,
});

export const haveAppointmentDeleteServices = payload => ({
  type: HAVE_APPOINTMENT_DELETE_SERVICES,
  payload,
});

export const appointmentDeleteServicesForcefully = payload => ({
  type: APPOINTMENT_DELETE_SERVICES_FORCEFULLY,
  payload,
});

export const appointmentDeleteServicesForcefullySuperAdmin = payload => ({
  type: APPOINTMENT_DELETE_SERVICES_FORCEFULLY_SUPER_ADMIN,
  payload,
});

export const appointmentDeleteServicesForcefullyResponse = payload => ({
  type: APPOINTMENT_DELETE_SERVICES_FORCEFULLY_RESPONSE,
  payload,
});
export const addServiceBusinessCategory = payload => ({
  type: ADD_SERVICES_BUSINESS_CATEGORY,
  payload,
});



// WEBPACK FOOTER //
// ./actions/ServicesAdminActions.js